export const GET_FASCE_ORARIE_AND_LOADING = "GET_FASCE_ORARIE_AND_LOADING";
export const EXPORT_FASCE_LOADING = "EXPORT_FASCE_LOADING";
export const CREATE_FASCE_ORARIE_DATA = "CREATE_FASCE_ORARIE_DATA";
export const CREATE_UPDATE_DELETE_FASCE = "CREATE_UPDATE_DELETE_FASCE";
export const GET_CURRENT_FASCE = "GET_CURRENT_FASCE";
